import React from "react";
import gql from "graphql-tag";
import { Mutation } from '@apollo/client/react/components';

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";

import { Link } from "react-router-dom";

import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";

import KVALogoWide from "./KVALogoWide";
import OpenSource from "./OpenSource";

import "../styles/Login.css";

const RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email) {
      isError
      message
    }
  }
`;

export default class PasswordReset extends React.Component {
  state: {
    email: string;
    result?: {
      isError: boolean;
      message: string;
    };
  };

  constructor(props: any) {
    super(props);

    this.state = {
      email: "",
      result: undefined,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
  }

  handleEmail(event: any) {
    this.setState({ ...this.state, email: event.target.value });
  }

  handleSubmit(event: any, reset_password: any) {
    event.preventDefault();
    reset_password({
      variables: { email: this.state.email },
    });
  }

  validateForm() {
    return this.state.email.length >= 5 && this.state.email.includes("@");
  }

  resultModal() {
    if (!this.state.result) {
      return <></>;
    }

    const variant = this.state.result.isError === true ? "danger" : "success";

    return <Alert variant={variant}>{this.state.result.message}</Alert>;
  }

  render() {
    return (
      <Mutation
        mutation={RESET_PASSWORD}
        onCompleted={(data: any) =>
          this.setState({ ...this.state, result: data["resetPassword"] })
        }
      >
        {(reset_password: any, { loading, error, data }: any) => {
          if (loading) {
            return <LoadingView />;
          }
          if (error) {
            if (error.networkError != null) {
              return <ErrorView error={error} />;
            }
          }

          return (
            <>
              <div id="big-wrapper">
                <Container fluid>
                  <div className="depth1">
                    <Row>
                      <Col xs={12} md={4} lg={3} className="fully bg-blue" />
                      <Col xs={12} md={8} lg={9} className="bg-img" />
                    </Row>
                  </div>
                  <div className="depth2">
                    <Container fluid>
                      <Row>
                        <Col xs={2} md={6} lg={6} />
                        <Col xs={10} md={6} lg={6}>
                          <div className="p-4">
                            <KVALogoWide />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={12}
                          md={{ span: 6, offset: 3 }}
                          lg={{ span: 4, offset: 2 }}
                        >
                          <div className="form-wrapper brt-3 brb-3">
                            <h2 className="underline p-4">
                              Passwort zurücksetzen
                            </h2>
                            <form
                              className="reset_password px-4 pb-4"
                              id="reset_password"
                              acceptCharset="UTF-8"
                              onSubmit={(event) =>
                                this.handleSubmit(event, reset_password)
                              }
                            >
                              <div className="form-group">
                                <div className="form-group email required account_email">
                                  <label
                                    className="control-label email required"
                                    htmlFor="account_email"
                                  >
                                    E-Mail Adresse
                                  </label>
                                  <input
                                    className="form-control string email required form-control"
                                    value={this.state.email}
                                    onChange={this.handleEmail}
                                    placeholder="E-Mail Adresse"
                                    type="email"
                                  />
                                </div>
                              </div>

                              <div className="row">
                                <div className="col">
                                  <input
                                    type="submit"
                                    className="btn btn-primary"
                                    name="commit"
                                    value="Reset-Link anfordern"
                                    disabled={!this.validateForm()}
                                  />
                                </div>
                                <div className="col psw text-right">
                                  <Link to="/login">Zurück zum Login</Link>
                                </div>
                              </div>
                            </form>
                            {this.resultModal()}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Container>
              </div>
              <OpenSource extern={true} />
            </>
          );
        }}
      </Mutation>
    );
  }
}
